import React, { useState } from "react";
import classes from "../customer.module.css";
import { Modal, Button, Typography } from "@mui/material";
import Box from "@mui/material/Box";
import { MdClose } from "react-icons/md";
import { ValidatorForm, TextValidator } from "react-material-ui-form-validator";
import { useDispatch } from "react-redux";
import successimage from "../../../../Assets/images/ILL_Sucess.png";
import { addTeamMembers } from "../../../../Redux/actions/customerActions";

// Same phone format the backend enforces (services/teamService.js
// _validateNewMembers) — catching this client-side avoids a round trip for
// the single most common rejection reason.
const MOBILE_REGEX = /^[6-9][0-9]{9}$/;

function AddTeamMemberModal({ teamId, sort, active, handleClose }) {
  const dispatch = useDispatch();
  const rootRef = React.useRef(null);

  const [modalToggle, setModalToggle] = useState(true);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const [userName, setUserName] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");

  const closeModal = () => {
    setModalToggle(false);
    handleClose(false);
  };

  const handleSubmit = () => {
    setError("");

    if (!MOBILE_REGEX.test(mobileNumber)) {
      setError("Enter a valid 10-digit mobile number");
      return;
    }

    setSubmitting(true);
    dispatch(
      addTeamMembers(
        teamId,
        [{ user_name: userName, mobile_number: mobileNumber }],
        sort,
        active,
        () => {
          setSubmitting(false);
          setSuccess(true);
        },
        (message) => {
          setSubmitting(false);
          setError(message || "Something went wrong. Please try again.");
        }
      )
    );
  };

  return (
    <div>
      <Modal
        open={modalToggle}
        aria-labelledby="server-modal-title"
        data-testid="add_team_member_modal"
        aria-describedby="server-modal-description"
        sx={{
          display: "flex",
          height: "max-content",
          marginTop: 10,
          justifyContent: "center",
        }}
        container={() => rootRef.current}
      >
        <Box
          sx={{
            position: "relative",
            bgcolor: "background.paper",
            borderRadius: 1,
            boxShadow: (theme) => theme.shadows[5],
          }}
          style={{ width: "min(92vw, 420px)", height: "auto" }}
        >
          <Button
            variant="text"
            sx={{ minWidth: "unset" }}
            className={classes.closebtn}
            onClick={closeModal}
          >
            <MdClose />
          </Button>
          {!success && (
            <div className={classes.AddMemberHeading}>
              <Typography>Add Team Member</Typography>
            </div>
          )}
          {!success ? (
            <ValidatorForm
              useref="form"
              onSubmit={handleSubmit}
              className={classes.formContainer}
            >
              <div className={classes.depFormContainer}>
                <div>
                  <div className="mt-3 mb-3">
                    <Typography className={classes.form_lable}>Name*</Typography>
                    <TextValidator
                      sx={{
                        "& legend": { display: "none" },
                        "& fieldset": { top: 0 },
                      }}
                      value={userName}
                      onChange={(e) => setUserName(e.target.value)}
                      fullWidth
                      size="small"
                      validators={["required"]}
                      errorMessages={["Name is required"]}
                    />
                  </div>
                </div>
                <div>
                  <div className="mb-3">
                    <Typography className={classes.form_lable}>
                      Mobile Number*
                    </Typography>
                    <TextValidator
                      sx={{
                        "& legend": { display: "none" },
                        "& fieldset": { top: 0 },
                      }}
                      value={mobileNumber}
                      onChange={(e) => setMobileNumber(e.target.value)}
                      fullWidth
                      size="small"
                      validators={["required", "matchRegexp:^[6-9][0-9]{9}$"]}
                      errorMessages={[
                        "Mobile number is required",
                        "Enter a valid 10-digit mobile number",
                      ]}
                    />
                  </div>
                </div>
                {error && (
                  <Typography style={{ color: "#BA1221", fontSize: 13 }}>
                    {error}
                  </Typography>
                )}
                <div className={"addMemberModalbtnSection"}>
                  <Button
                    variant="contained"
                    type="submit"
                    fullWidth
                    disabled={submitting}
                    className={`mb-4`}
                  >
                    {submitting ? "Adding..." : "Add Member"}
                  </Button>
                </div>
              </div>
            </ValidatorForm>
          ) : (
            <div className={classes.addMembersuccess}>
              <img src={successimage} alt="Success logo" width={200} height={200} />
              <Typography className={classes.successMainText}>
                Member Added Successfully
              </Typography>
              <Typography className={classes.successSubText}>
                The new member has been added to the team.
              </Typography>
            </div>
          )}
        </Box>
      </Modal>
    </div>
  );
}

export default AddTeamMemberModal;
